export const subjectsData = [
  {
    id: 53453454351,
    icon_name: "solar:globus-bold",
    color: "#F77E23",
    title: "World history",
  },
  {
    id: 53453454352,
    icon_name: "solar:globus-bold",
    color: "#1B9C85",
    title: "History of Uzbekistan",
  },
  {
    id: 53453454353,
    icon_name: "solar:globus-bold",
    color: "#1D267D",
    title: "Geography",
  },
  {
    id: 53453454354,
    icon_name: "solar:globus-bold",
    color: "#19A7CE",
    title: "Mother tongue",
  },
  {
    id: 53453454355,
    icon_name: "solar:globus-bold",
    color: "#1B9C85",
    title: "Physics",
  },
  {
    id: 53453454356,
    icon_name: "solar:globus-bold",
    color: "#F77E23",
    title: "English",
  },
  {
    id: 53453454357,
    icon_name: "solar:globus-bold",
    color: "#FFD95A",
    title: "Mathematics",
  },
  {
    id: 53453454357,
    icon_name: "solar:globus-bold",
    color: "#E76161",
    title: "Russian",
  },
];
